import React, { useEffect, useState } from "react";
import { message } from "antd";
import ConsentServices from "../Services/ConsentServices";
import MedicalService from "../Services/MedicalService";
import moment from "moment";
import { notifyDoctor } from "../config/firebase";
import content from "../utils/TermsContent";

function GiveConsent() {
  const [params, setParams] = useState();
  const [showConsent, setShowConsent] = useState(true);
  const [consentdata, setConsentdata] = useState();
  const [loading, setLoading] = useState(true);
  const [checkedItems, setCheckedItems] = useState({
    terms: false,
    privacy: false,
    doctors: false,
    hospitals: false,
    pharmacy: false,
    diagnostics: false,
  });
  const [appointmentData, setAppointmentData] = useState({});

  const getCodeFromURL = () => {
    const query = window.location.search;
    const codeMatch = query.match(/ref=([^&]*)/);
    return codeMatch ? codeMatch[1] : null;
  };

  useEffect(() => {
    let param = getCodeFromURL();
    setParams(param);

    if (param) {
      getConsent(param);
    }
  }, []);

  const getConsent = async (params) => {
    setLoading(true);
    try {
      let appointmentDetails = await ConsentServices.GetAppointmentId(params);
      setAppointmentData(appointmentDetails?.data[0]);

      const payload = {
        // account_Id: appointmentDetails?.data[0]?.account_Id,
        // clinic_Id: appointmentDetails?.data[0]?.clinic_Id,
        patientId: appointmentDetails?.data[0]?.patientId,
      };

      const response = await ConsentServices.getconsentFilterForLink(payload);

      setCheckedItems({
        terms: response.data[0]?.termsCond === "Y" ? true : false,
        privacy: response.data[0]?.privacyPolicy === "Y" ? true : false,
        doctors: response.data[0]?.shareMedWithDocs === "Y" ? true : false,
        hospitals: response.data[0]?.shareMedWithHosp === "Y" ? true : false,
        pharmacy:
          response.data[0]?.shareEpresWithPharmacy === "Y" ? true : false,
        diagnostics:
          response.data[0]?.shareEpresWithDiagnostics === "Y" ? true : false,
      });

      const allConsentsGiven = [
        response.data[0]?.termsCond,
        response.data[0]?.privacyPolicy,
        response.data[0]?.shareMedWithDocs,
        response.data[0]?.shareMedWithHosp,
        response.data[0]?.shareEpresWithPharmacy,
        response.data[0]?.shareEpresWithDiagnostics,
      ].every((value) => value === "Y");

      if (allConsentsGiven) {
        let payload = {
          patientId: appointmentDetails?.data[0]?.patientId,
          userId: appointmentDetails?.data[0]?.userId,
          accessDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        };
        fetchRecords(payload);
        setShowConsent(false);
        setLoading(false);
      } else {
        setConsentdata(response.data);
        setShowConsent(true);
        setLoading(false);
      }
    } catch (e) {
      console.error("Error fetching consent:", e);
    }
  };

  const handleChange = (event) => {
    const { name, checked } = event.target;
    setCheckedItems((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const formatDate = () => {
    const now = new Date();
    return now
      .toLocaleString("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  };

  const handleSubmit = async () => {
    try {
      const postData = {
        appointmentId: appointmentData?.appointmentId,
        account_Id: appointmentData?.account_Id,
        clinic_Id: appointmentData?.clinic_Id,
        createdBy: appointmentData?.patientId,
        createdDate: formatDate(),
        modifiedBy: appointmentData?.patientId,
        modifiedDate: formatDate(),
        patientId: appointmentData?.patientId,
        privacyPolicy: checkedItems.privacy ? "Y" : "N",
        shareEpresWithDiagnostics: checkedItems.diagnostics ? "Y" : "N",
        shareEpresWithPharmacy: checkedItems.pharmacy ? "Y" : "N",
        shareMedWithDocs: checkedItems.doctors ? "Y" : "N",
        shareMedWithHosp: checkedItems.hospitals ? "Y" : "N",
        status: 1,
        termsCond: checkedItems.terms ? "Y" : "N",
      };
      const response =
        await ConsentServices.consentPostFromInviteLink(postData);

      if (
        postData?.shareEpresWithDiagnostics == "Y" &&
        postData?.shareEpresWithPharmacy == "Y" &&
        postData?.shareMedWithDocs == "Y"
      ) {
        let payload = {
          patientId: appointmentData?.patientId,
          userId: appointmentData?.userId,
          accessDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        };
        fetchRecords(payload);
        setShowConsent(false);
        setLoading(false);

        message.success("Consent submitted successfully!");
      } else {
        message.success("Give Consent to share the Records");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("Failed to submit consent. Please try again.");
    }
  };

  const activePatient = JSON.parse(sessionStorage.getItem("patientData"));
  const patientCode = activePatient?.patientId;
  const [medicalRecord, setMedicalRecord] = useState(null);

  const [checkboxState, setCheckboxState] = useState({
    medicalHistory: false,
    prescription: false,
    reports: false,
    vitals: false,
    agree: true,
  });

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const handleShareClick = async () => {
    let payload = {
      medicalHistory: checkboxState.medicalHistory ? "Y" : "N",
      prescription: checkboxState.prescription ? "Y" : "N",
      reports: checkboxState.reports ? "Y" : "N",
      vitals: checkboxState.vitals ? "Y" : "N",
      appointmentId: appointmentData?.appointmentId,
      status: 1,
    };
    try {
      const response =
        await MedicalService.ShareMedicalrecordsFromLink(payload);
      await notifyDoctor(
        appointmentData?.patientId,
        appointmentData?.appointmentId,
        appointmentData?.patientName,
        appointmentData?.userId,
      );
      message.success("Medical Records Shared");
    } catch (error) {
      console.error("Error sharing medical records:", error);
    }
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes(),
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const fetchRecords = async (payload) => {
    // let payload = {
    //   patientId: appointmentData?.patientId,
    //   userId: appointmentData?.userId,
    //   accessDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
    // };
    try {
      const result = await MedicalService.getShareMedicalrecords(payload);
      setMedicalRecord(result.data);
      setCheckboxState({
        medicalHistory: result.data[0]?.medicalHistory === "Y",
        prescription: result.data[0]?.prescription === "Y",
        reports: result.data[0]?.reports === "Y",
        vitals: result.data[0]?.vitals === "Y",
        // agree: result.data[0]?.status === 1,
      });
    } catch (error) {
      console.error("Error fetching medical records:", error);
    }
  };

  return (
    <div>
      {loading ? (
        <div>Loading.....</div>
      ) : (
        <div>
          {showConsent ? (
            <div className="min-h-screen">
              <div className=" mt-5">
                <div className="p-6 space-y-7  scrollWidth">
                  {/* Terms & Conditions */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="terms"
                      checked={checkedItems.terms}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Terms & Conditions</span>
                  </label>
                  {checkedItems.terms && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.terms}
                    </div>
                  )}

                  {/* Privacy Policy */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="privacy"
                      checked={checkedItems.privacy}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Privacy Policy</span>
                  </label>
                  {checkedItems.privacy && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.privacyPolicy}
                    </div>
                  )}

                  {/* Share Medical Records with Doctors */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="doctors"
                      checked={checkedItems.doctors}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Share Medical Records with Doctors</span>
                  </label>
                  {checkedItems.doctors && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.shareMedRecWithDoc}
                    </div>
                  )}

                  {/* Share Medical Records with Hospitals */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="hospitals"
                      checked={checkedItems.hospitals}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Share Medical Records with Hospitals</span>
                  </label>
                  {checkedItems.hospitals && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.shareMedWithHos}
                    </div>
                  )}

                  {/* Share e-Prescription with Pharmacy */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="pharmacy"
                      checked={checkedItems.pharmacy}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Share e-Prescription with Pharmacy</span>
                  </label>
                  {checkedItems.pharmacy && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.ePresWithPhar}
                    </div>
                  )}

                  {/* Share e-Prescription with Diagnostics */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="diagnostics"
                      checked={checkedItems.diagnostics}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Share e-Prescription with Diagnostics</span>
                  </label>
                  {checkedItems.diagnostics && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.ePresWithDiag}
                    </div>
                  )}
                </div>
                <div className="flex space-x-4 justify-end mt-5">
                  <button
                    onClick={handleSubmit}
                    className="px-4 py-1 bg-[#189FAA] text-white rounded-lg hover:bg-[#338f97]"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="fixed top-0 left-0 w-full h-full flex  z-10 items-center justify-center bg-gray-800 bg-opacity-50">
              <div
                className="relative w-96 p-4 bg-white border border-gray-300 rounded-md shadow-lg"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="p-1">
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="medicalHistory"
                      name="medicalHistory"
                      className="form-checkbox mr-2 text-[#189FAA] border-gray-300 rounded focus:ring-[#189FAA] accent-[#189FAA] cursor-pointer"
                      checked={checkboxState.medicalHistory}
                      onChange={handleCheckboxChange}
                    />
                    <label
                      htmlFor="medicalHistory"
                      className="text-lg font-medium"
                    >
                      Medical History
                    </label>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="prescription"
                      name="prescription"
                      className="form-checkbox mr-2 text-[#189FAA] border-gray-300 rounded focus:ring-[#189FAA] accent-[#189FAA] cursor-pointer"
                      checked={checkboxState.prescription}
                      onChange={handleCheckboxChange}
                    />
                    <label
                      htmlFor="prescription"
                      className="text-lg font-medium"
                    >
                      Prescription
                    </label>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="vitals"
                      name="vitals"
                      className="form-checkbox mr-2  border-gray-300 rounded focus:ring-[#189FAA] accent-[#189FAA] cursor-pointer"
                      checked={checkboxState.vitals}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="vitals" className="text-lg font-medium">
                      Vitals
                    </label>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="reports"
                      name="reports"
                      className="form-checkbox mr-2  border-gray-300 rounded focus:ring-[#189FAA] accent-[#189FAA] cursor-pointer"
                      checked={checkboxState.reports}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="reports" className="text-lg font-medium">
                      Reports
                    </label>
                  </div>
                  <hr className="mt-3" />
                  <div className="flex items-center gap-2 pt-5">
                    <input
                      type="checkbox"
                      id="agree"
                      name="agree"
                      className="form-checkbox mr-2 text-[#189FAA] border-gray-300 rounded focus:ring-[#189FAA] accent-[#189FAA] cursor-pointer"
                      checked={true}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="agree" className="text-base text-gray-700">
                      I agree to share my Medical Records with the doctor
                    </label>
                  </div>
                  <div className="flex justify-end gap-3 mt-4">
                    <button
                      onClick={handleShareClick}
                      className={
                        "border-brand-primaryColor border rounded-md p-2 text-white flex items-center text-sm  bg-primaryColor"
                      }
                    >
                      Share
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default GiveConsent;
